// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.textBox {
    width: 100%;
    display: flex;
    flex-direction:column;
}
`, "",{"version":3,"sources":["webpack://./src/app/appbuilder/controls/textarea/textarea.theme.control.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa;IACb,qBAAqB;AACzB","sourcesContent":[".textBox {\n    width: 100%;\n    display: flex;\n    flex-direction:column;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
